import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import type { StylesMap } from 'Types';

export const buttonSize = Theme.BU * 5;
export const SEEK_ICON_SIZE = 52;

const baseStyles: StylesMap = StyleSheet.create({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: Device.isTabletOrWeb ? '10%' : '5%'
    },
    volumeContainer: {
        height: 40,
        marginTop: '5%'
    },
    controlsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'space-between',
        width: '40%'
    },
    hasArchiveControls: {
        width: '55%'
    },
    playPauseIcon: {
        width: 64,
        height: 80
    },
    loader: {
        position: 'absolute',
        width: buttonSize,
        height: buttonSize
    },
    icon: {
        width: 58,
        height: 58,
        paddingHorizontal: 10
    },
    divider: {
        width: 1,
        height: '80%',
        backgroundColor: 'rgba(255, 255, 255, 0.25)'
    },
    nextPrevIcon: {
        width: 22,
        height: 31,
        marginHorizontal: 20
    },
    interactable: {
        minHeight: 58,
        justifyContent: 'center'
    },
    spacing:{
        paddingHorizontal:30
    }
});

if (Device.isTablet) {
    baseStyles.controlsContainer = {
        ...baseStyles.controlsContainer,
        justifyContent: 'space-between',
        width: '30%'
    };
    baseStyles.playPauseIcon = {
        width: buttonSize + Theme.BU,
        height: buttonSize + Theme.BU
    };
    baseStyles.divider = {
        ...baseStyles.divider,
        width: 2
    };
    baseStyles.nextPrevIcon = {
        width: 21,
        height: 30
    };
    baseStyles.icon = {
        width: 52,
        height: 52,
        paddingHorizontal:20
    };
    baseStyles.hasArchiveControls = {
        width: '50%'
    };
}

if (Device.isWeb) {
    baseStyles.controlsContainer = {
        ...baseStyles.controlsContainer,
        width: '20%',
        justifyContent: 'center'
    };
    baseStyles.hasArchiveControls = {
        width: '50%'
    };
    baseStyles.icon = {
        width: 52,
        height: 52,
    };
    baseStyles.playPauseIcon={
        ...baseStyles.playPauseIcon,
        marginLeft:10,
        marginRight:20,
    };
    baseStyles.nextPrevIcon={
        ...baseStyles.nextPrevIcon,
        paddingLeft:10,
        paddingRight:10,
        marginVertical:11,
    };
    baseStyles.interactable={
        ...baseStyles.interactable,
        paddingVertical:14,
        marginHorizontal: 10,
    };
}

export default baseStyles;
